import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5vokhafgu0: FaireBrandEntity = {
  token: "b_5vokhafgu0",
  type: "brand",
  name: "Final Touch",
  avatarUrl:
    "https://cdn.faire.com/fastly/8a69c9379a031f960f7eb7633cf33a5ab1e4e5bcd54656308f2326df75a42170.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/775300beeb31a2153baa943282a2ba030d73182d418f8455e87eac596016ad4a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8a69c9379a031f960f7eb7633cf33a5ab1e4e5bcd54656308f2326df75a42170.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/775300beeb31a2153baa943282a2ba030d73182d418f8455e87eac596016ad4a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 60,
  rating: 4.9,
  reviewCount: 49,
  isTopShop: true,
  isInsider: true,
  description:
    "Final Touch Apparel is a California-based clothing company offering young, contemporary, and stylish fashion in the wholesale market. Our brand philosophy centers around creating effortless, innovative styles while ensuring high-quality, timeless designs that meet the diverse needs of our customers. Final Touch Collection is an international brand, selling across North America and Europe, and is committed to providing fashion that transcends trends and offers lasting appeal.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:40.935Z",
    importedBy: "entity-db-cli",
  },
};
